module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-small-153fefcbcde372018761e5069fad7200.jpg";